import * as React from "react";
import { forwardRef } from "react";
const SvgDownTrendIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 22, height: 13, viewBox: "0 0 22 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M20.625 11.8125L11.6875 2.1875L6.1875 8.375L1.375 3.5625", stroke: "#D12525", strokeWidth: 2, strokeMiterlimit: 10 }), /* @__PURE__ */ React.createElement("path", { d: "M13.75 11.8125H20.625V4.9375", stroke: "#D12525", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "square" }));
const ForwardRef = forwardRef(SvgDownTrendIcon);
export { ForwardRef as ReactComponent };
